const DEFAULT_SUPPRESS_MS = 500;

let suppressUntil = 0;

function now(): number {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}

/**
 * Mobile sheet outside-tap dismissal happens on pointerdown, before the browser's
 * follow-up mouse/touch create event can reach the calendar behind it.
 */
export function suppressCalendarBackgroundCreate(ms = DEFAULT_SUPPRESS_MS): void {
  suppressUntil = Math.max(suppressUntil, now() + ms);
}

export function isCalendarBackgroundCreateSuppressed(): boolean {
  return now() < suppressUntil;
}

export function resetCalendarBackgroundCreateSuppressionForTest(): void {
  suppressUntil = 0;
}
